import React, { HTMLAttributes } from 'react';
import cn from 'classnames';
import styles from './DownloadIcon.module.scss';
import { PropsWithTestId } from '../../../../../../../types';

export function DownloadIcon({
  className,
  testId,
}: PropsWithTestId<HTMLAttributes<HTMLElement>>) {
  const iconWrapper = cn(styles.iconWrapper, className);

  return (
    <div data-testid={testId} className={iconWrapper}>
      <i />
    </div>
  );
}

DownloadIcon.defaultProps = {
  testId: 'hub-module-download-icon',
};
